<template>
  <div>
    <v-row v-if="!loading" no-gutters>
      <v-col cols="12">
        <v-card-text>
          <v-row no-gutters>
            <v-col v-if="activeInsurances.length" cols="6" class="px-2">
              <CustomerInsurance v-for="insurance in activeInsurances" :key="insurance.bookingNumber" :insurance="insurance" :customer="customer" />
            </v-col>
            <v-col v-if="pastInsurances.length" cols="12" class="my-2 px-2">
              <v-card class="mt-4">
                <v-card-title class="third white--text font-weight-bold">
                  <span class="col-11">Historique des Assurances</span>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="headers"
                    :items="pastInsurances"
                    :height="tableHeight"
                    :hide-default-footer="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else-if="!activeInsurances.length && !pastInsurances.length">
              <v-card class="mt-4">
                <v-card-title class="third white--text font-weight-bold">
                  <span class="ml-2">Pas d'assurance</span>
                </v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="6" class="px-2">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>L'utilisateur n'a pas d'assurance</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
    <v-skeleton-loader
      v-else
      class="mx-auto"
      max-width="790"
      type="card"
    />
  </div>
</template>

<script>
import { ref, onBeforeMount, watch, computed } from '@vue/composition-api';
import { format, isAfter } from 'date-fns';
import { getCustomerAllInsurance } from '../../../helpers/request';
import CustomerInsurance from './CustomerInsurance.vue';

export default {
  components: { CustomerInsurance },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const customerObject = ref(props.customer);
    const loading = ref(false);
    const activeInsurances = ref([]);
    const pastInsurances = ref([]);
    const tableHeight = computed(() => window.innerHeight * 0.25);

    const requestCustomerInsurances = async () => {
      loading.value = true;
      activeInsurances.value = [];
      pastInsurances.value = [];
      const requestInsurances = await getCustomerAllInsurance(customerObject.value.uuid);

      if (requestInsurances && requestInsurances.success && requestInsurances.data) {
        requestInsurances.data.insurances.map(ins => {
          const insurance = {
            ...ins.data,
            startDate: format(new Date(ins.data.startDate), 'dd/MM/yyyy'),
            endDate: format(new Date(ins.data.endDate), 'dd/MM/yyyy'),
            subscriptionDate: ins.data.subscriptionDate ? format(new Date(ins.data.subscriptionDate), 'dd/MM/yyyy') : '--'
          };
          if (isAfter(new Date(), new Date(ins.data.endDate))) {
            pastInsurances.value.push(insurance);
          } else {
            activeInsurances.value.push(insurance);
          }
        });
      }
      loading.value = false;
    };

    onBeforeMount(() => {
      requestCustomerInsurances();
    });

    watch(() => props.customer, () => {
      customerObject.value = props.customer;
      requestCustomerInsurances();
    });

    const headers = computed(() => [
      { text: 'Nom de l\'assurance', value: 'type', width: '25%' },
      { text: 'Date de début', value: 'startDate', width: '25%' },
      { text: 'Date de fin', value: 'endDate', width: '25%' },
      { text: 'Numéro de l’assurance', value: 'bookingNumber', width: '25%' }
    ]);

    return { activeInsurances, pastInsurances, loading, customerObject, headers, tableHeight };
  }
};
</script>
